export const MODAL_NAME = 'ClientMonitoringModal'
